import { useParams } from 'react-router-dom'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import { useEffect, useState } from 'react'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import eventBus from 'services/eventBus'
import { useSetRecoilState } from 'recoil'
import recoilStateUpdaters from 'recoil/recoil.stateUpdaters'
import eventsTableAtom from '../../components/EventsTable/eventsTable.atom'
import useEvent from '../../hooks/useEvent'
import eventsApi from '../../events.api'
import EventSheet from '../../components/EventSheet'

const EventPage = () => {
  const { wait, loading: updateLoading } = useHttpLoader()

  const params = useParams()
  const id = +params.id
  const { event, loading } = useEvent(id)
  const [draft, setDraft] = useState(event)
  const setState = useSetRecoilState(eventsTableAtom)

  useEffect(() => {
    setDraft(event)
  }, [event])

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(eventsApi.update(draft, id), (resp) => {
      if (resp.status === 'success') {
        recoilStateUpdaters.itemUpdated(setState, resp.body)
        eventBus.pub('ntf.message', { type: 'info', message: 'Событие обновлено' })
      }
    })
  }

  const renderContent = () => {
    if (!draft || loading) {
      return (
        <div className='flex-page-center'>
          <ThreeDotsLoader />
        </div>
      )
    }

    return (
      <>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Событие</h2>
          </div>
        </div>
        <EventSheet event={draft} onChange={handleChange}>
          <Button theme='primary' loading={updateLoading} style={{ width: 'fit-content' }} onClick={handleSave}>
            Сохранить
          </Button>
        </EventSheet>
      </>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>{renderContent()}</TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default EventPage
